/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the PageRequest interface.
 */
export function instanceOfPageRequest(value) {
    var isInstance = true;
    return isInstance;
}
export function PageRequestFromJSON(json) {
    return PageRequestFromJSONTyped(json, false);
}
export function PageRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'size': !exists(json, 'size') ? undefined : json['size'],
        'page': !exists(json, 'page') ? undefined : json['page']
    };
}
export function PageRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'size': value.size,
        'page': value.page
    };
}
